import { useEffect } from 'react';
import { NO_LEAD_AVAILABLE, NO_STATUS_AVAILABLE } from 'src/analytics/constants';
import { getHomeLoansDashboardViewEvent } from 'src/analytics/events/dashboard/getHomeLoansDashboardViewEvent';
import { trackEvent } from 'src/analytics/events/trackEvent';
import { HOME_LOANS_DASHBOARD_VIEW_EVENTS } from 'src/analytics/events/registeredEvents';
import { MaybeLeadID, MaybeLoanID } from 'src/common/types';
import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';

type AnalyticsData = {
    leadID: MaybeLeadID;
    loanID: MaybeLoanID;
    loading: boolean;
    status: ZHLPersonalizedNextStepState | null;
};

export const useTrackViewEvent = ({ leadID, status, loanID, loading }: AnalyticsData) => {
    useEffect(() => {
        const shouldDeferAnalytic = loading || !loanID;
        if (shouldDeferAnalytic) {
            return;
        }
        trackEvent(
            getHomeLoansDashboardViewEvent({
                event: HOME_LOANS_DASHBOARD_VIEW_EVENTS.DASHBOARD_LOADED,
                journey_stage_cd: status ?? NO_STATUS_AVAILABLE,
                lead_id: leadID ?? NO_LEAD_AVAILABLE,
            })
        );
    }, [leadID, loanID, status, loading]);
};
